import './style.scss';
import { IntroRb } from './intro-content';

function IntroBlock(props) {

  const ChannelIntro = (channel) => {
    switch (channel) {
      case 'restaurangbutiker':
        return IntroRb;
      default:
        return null;
    }
  }

  const ChannelComponent = ChannelIntro(props.channel);

  return ChannelComponent ? (
    <div className="intro-content">
      <ChannelComponent/>
    </div>
  ) : null;
}

export default IntroBlock;
